// test1117
(1117 && 0);
